<div class="status">
  <mat-chip *ngIf="onlineStatus === 'online'" 
    class="badge badge-green">
    Online
  </mat-chip>
  <mat-chip *ngIf="onlineStatus === 'offline'" 
    class="badge badge-red">
    Offline
  </mat-chip>
  <mat-chip *ngIf="onlineStatus === 'not_activated'" 
    class="badge badge-yellow">
    Not Activated
  </mat-chip>
</div> 